import React from "react";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";

export default function Blackbox() {
  return (
    <div className="max-w-2xl mx-auto p-4">
      <h1 className="text-2xl font-bold mb-2">Blackbox</h1>
      <div className="mb-2 flex items-center space-x-2 text-indigo-500 font-medium text-sm">
        <a
          href="https://github.com/Luca-W-D/Blackbox"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1"
        >
          GitHub Repo <ArrowTopRightOnSquareIcon className="w-4 h-4 inline" />
        </a>
      </div>

      <div className="mb-2 text-gray-700">
        Blackbox is a distributed machine learning project that runs text and
        image recognition on a network of game bots to provide paying customers
        with in-game market data. The system enables large-scale, automated data
        collection and analysis.
      </div>

      <span className="inline-flex flex-wrap mb-8 gap-1">
        <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-blue-100 text-blue-700 border border-blue-200">
          Python
        </span>
        <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-blue-100 text-blue-700 border border-blue-200">
          JavaScript (Node)
        </span>
        <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-blue-100 text-blue-700 border border-blue-200">
          PHP
        </span>
        <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-blue-100 text-blue-700 border border-blue-200">
          HTML/CSS/JS
        </span>
        <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-700 border border-green-200">
          REST APIs
        </span>
        <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-700 border border-green-200">
          Machine Learning
        </span>
        <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-700 border border-green-200">
          Customer-Facing
        </span>
        <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-700 border border-green-200">
          Distributed
        </span>
      </span>

      <div className="mb-6">
        <h2 className="font-semibold text-base mb-1">Components</h2>
        <ul className="list-disc ml-6 text-gray-700">
          <li>In-game bot scripts for collecting data </li>
          <li>Dedicated API for persistent data storage </li>
          <li>Frontend gallery with example interactions </li>
          <li>Discord.js powered Discord bot for community interaction </li>
          <li>Background services for image intake and username lookup </li>
        </ul>
      </div>

      <div className="mb-6">
        <h2 className="font-semibold text-base mb-1">Features</h2>
        <ul className="list-disc ml-6 text-gray-700">
          <li>
            Distributed in-game data collection via standalone Windows game
            clients
          </li>
          <li>Custom configuration for different screen resolutions</li>
          <li>
            Persistent storage and retrieval of collected data through a PHP API
          </li>
          <li>Automated playlist and market data generation for users</li>
          <li>Background APIs for image processing and username lookup</li>
        </ul>
      </div>

      <div className="mb-6">
        <h2 className="font-semibold text-base mb-1">How It Works</h2>
        <ul className="list-disc ml-6 text-gray-700">
          <li>
            Game bots run on dedicated Windows machines, collecting in-game
            screenshots and data.
          </li>
          <li>
            OCR (via Pytesseract) and image processing extract relevant
            information from screenshots.
          </li>
          <li>
            Data is sent to a central PHP API for storage and later analysis.
          </li>
          <li>
            Background services provide additional APIs for image intake and
            username lookups.
          </li>
          <li>
            Market data is analyzed and can be delivered to paying customers or
            community members.
          </li>
        </ul>
      </div>
    </div>
  );
}
